import React, { FormEvent, useCallback, useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import api, { operation } from '../../services/axios'
import * as actions from '../../store/modules/cerc/actions'
import { StoreState } from '../../store'
import { cnpjCpfMask, parseDate } from '../../utils/masks'
import { arranjos, arranjosPrincipais, getIcon } from '../../utils/arranjos'
import {
    UnidadeRecebivelProtocol,
    PagamentosProtocol,
    PagamentoProtocol,
    OrderByDate,
    OrderBy,
} from './interfaces'
import Loading from '../../components/Loading'
import Dialog from '../../components/Dialog'
import {
    Checkbox,
    InputLabel,
    MenuItem,
    Pagination,
    Select,
    SelectChangeEvent,
} from '@mui/material'
import { MdKeyboardArrowUp, MdMoreVert } from 'react-icons/md'

import {
    Container,
    SearchAgenda,
    Content,
    UnidadeRecebivel,
    Schedule,
    Header,
    ContainerUR,
    TableUR,
} from './styles'
import PaymentCard from '../../components/PaymentCard'
// import { credenciadoras } from '../../utils/credenciadoras'
import FormDialog from '../../components/FormDialog'

import toast from 'react-hot-toast'
import { get } from 'lodash'
import { calcDiffDays } from '../../utils/date'

import { Link, useNavigate } from 'react-router-dom'
import { selectedMenu } from '../../store/modules/menu/actions'
import { BsPlus } from 'react-icons/bs'
import { Popover } from '@headlessui/react'
import DatePicker from 'react-datepicker'
import { useCredenciadoras } from '../../hooks/credenciadoras'
import dayjs from '../../libs/dayjs'
import { agendaResponse } from '../../store/modules/auth/actions'
import { OptInAlert } from '../../components/OptInAlert'
import { DocumentRequiredAlert } from '../../components/DocumentRequiredAlert'

const Pagamento: React.FC = () => {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const {
        verificationC,
        cnpj_cpf,
        empresa,
        solicitouAgendaHoje,
        isDocumentValid,
    } = useSelector((state: StoreState) => state.auth.user)
    const { unidadesRecebiveisSelecionadas } = useSelector(
        (state: StoreState) => state.cerc
    )
    const { suasCredenciadoras } = useCredenciadoras()
    const [isLoading, setIsLoading] = useState(false)
    const [data, setData] = useState({} as PagamentosProtocol)
    const [unidadesRecebiveis, setUnidadesRecebiveis] = useState<
        UnidadeRecebivelProtocol[]
    >([])
    const [pagUR, setPagUR] = useState(1)
    const [count, setCount] = useState(0)
    const [seeDetails, setSeeDetails] = useState(false)
    const [seeDetailsPayment, setSeeDetailsPayment] = useState(
        {} as PagamentoProtocol
    )
    const [isformDialogOpen, setIsformDialogOpen] = useState(false)
    const [formDialogData, setFormDialogData] = useState(
        {} as UnidadeRecebivelProtocol
    )
    const [dateFilter, setDateFilter] = useState<number | string>(0)
    const [paymentFilter, setPaymentFilter] = useState<number | string>(0)
    const [credenciadora, setCredenciadora] = useState('')
    const [bandeiras, setBandeiras] = useState<string[]>([
        'MCC',
        'ECC',
        'VCC',
        'HCC',
        'ACC',
    ])
    const [ordenarPorDataLiquidacao, setOrdenarPorDataLiquidacao] =
        useState<OrderBy>('asc')
    const [ordenarPorValor, setOrdenarPorValor] = useState<OrderBy>(null)
    const [ordenarPorPeriodo, setOrdenarPorPeriodo] = useState({
        dataInicio: '',
        dataFim: '',
    } as OrderByDate)
    const [creds, setCreds] = useState([])
    const [customValue, setCustomValue] = useState<string | number>('')
    const [dataLiquidacaoInicial, setDataLiquidacaoInicial] = useState('')
    const [dataLiquidacaoFinal, setDataLiquidacaoFinal] = useState('')
    const [dateRange, setDateRange] = useState<Array<null | Date>>([null, null])
    const [startDate, endDate] = dateRange

    // useEffect(() => {
    //     async function getCreds() {
    //         operation.attempt(async (currentAttempt) => {
    //             try {
    //                 // setIsLoading(true)

    //                 if (unidadesRecebiveis.length === 0 && !credenciadora) {
    //                     const { data } = await api.get(
    //                         `/credenciadoras/${cnpj_cpf}`
    //                     )
    //                     setCreds(data)
    //                 }
    //                 // setIsLoading(false)
    //             } catch (e: any) {
    //                 // toast.error(erro)
    //                 const status = get(e, 'response.status', '')
    //                 // toast.error(erro)
    //                 // setIsLoading(false)

    //                 if (status === 401) {
    //                     if (operation.retry(e)) return
    //                 }
    //             }
    //         })
    //     }

    //     getCreds()
    // }, [unidadesRecebiveis, cnpj_cpf, credenciadora])
    const getAgenda = useCallback(async () => {
        operation.attempt(async (currentAttempt) => {
            try {
                setIsLoading(true)
                // let existCredInCommom
                // Object.keys(credenciadoras).find((credenciadora) => {
                //     existCredInCommom = creds.find((cred) => {
                //         return cred === credenciadora
                //     })
                //     if (existCredInCommom) {
                //         return true
                //     }
                //     return false
                // })
                // if(!existCredInCommom) return

                const isCredenciadoraSetted =
                    credenciadora !== ''
                        ? credenciadora
                        : Object.keys(suasCredenciadoras)[0]
                if (!isCredenciadoraSetted) {
                    return setIsLoading(false)
                }
                !credenciadora && setCredenciadora(isCredenciadoraSetted)

                const { data } = await api.post(
                    `/unidadesRecebiveis/${pagUR}`,
                    {
                        cnpj_cpf: cnpj_cpf,
                        bandeiras: bandeiras,
                        ordenarPorDataLiquidacao,
                        ordenarPorValor,
                        ordenarPorPeriodo: {
                            dataInicio: startDate
                                ? dayjs(startDate).format('YYYY-MM-DD')
                                : '',
                            dataFim: endDate
                                ? dayjs(endDate).format('YYYY-MM-DD')
                                : '',
                        },
                        credenciadora: isCredenciadoraSetted,
                    }
                )
                setUnidadesRecebiveis(data.unidadesRecebiveis)
                setCount(data.quantPaginas)
                setIsLoading(false)
            } catch (e: any) {
                // toast.error(erro)
                setIsLoading(false)
                const status = get(e, 'response.status', '')
                // toast.error(erro)
                if (status === 401) {
                    if (operation.retry(e)) return
                }
            }
        })
    }, [
        cnpj_cpf,
        pagUR,
        bandeiras,
        ordenarPorDataLiquidacao,
        ordenarPorValor,
        startDate,
        endDate,
        credenciadora,
        suasCredenciadoras,
    ])

    useEffect(() => {
        getAgenda()
    }, [cnpj_cpf, getAgenda])

    // filtros da tabela
    let filtredPayments: any = []

    filtredPayments = data?.pagamentos?.filter(
        (pagamento: PagamentoProtocol) => {
            const dataLiquidacao: string =
                pagamento.dataLiquidacaoEfetiva || '2022-08-20'
            const dataLiquidacaoParsed = parseDate(dataLiquidacao)

            const diffDays = calcDiffDays(dataLiquidacaoParsed)
            if (Number(dateFilter) !== 0) {
                return diffDays <= Number(dateFilter) ////
            }
            return true
        }
    )

    filtredPayments = filtredPayments?.filter(
        (pagamento: PagamentoProtocol) => {
            if (Number(paymentFilter) !== 0) {
                return pagamento.beneficiario !== cnpj_cpf
            }

            return pagamento.beneficiario === cnpj_cpf
        }
    )

    if (!verificationC) {
        return <OptInAlert />
    }

    if (!isDocumentValid) {
        return <DocumentRequiredAlert />
    }
    async function handleSubmit(e: FormEvent) {
        e.preventDefault()

        if (solicitouAgendaHoje) {
            toast.error('O usuário já solicitou a agenda hoje.')
            return
        }

        dispatch(actions.cercDeleteAllURs())
        const diaDaSemana = dayjs().day()

        if (diaDaSemana === 0 || diaDaSemana === 6) {
            toast.error(
                'Não é possível solicitar a agenda nos finais de semana.'
            )
            return
        }

        // a agenda está disponível apenas entre as 9 horas da manha e as 20 horas da noite
        const timeOfDay = dayjs().hour()

        if (timeOfDay < 9 || timeOfDay > 19) {
            toast.error(
                'O horario de disponibilidade para solicitar a agenda é após as 9 horas ou antes das 20 horas.'
            )
            return
        }
        try {
            setIsLoading(true)
            await api.post('/agenda/solicitar', {
                cnpj_cpf: cnpj_cpf,
            })
            // fazer o reloading
            setIsLoading(false)
            dispatch(agendaResponse({ solicitouAgendaHoje: true }))
        } catch (error) {
            const message = get(error, 'response.data.error', '')
            toast.error(message)
            setIsLoading(false)
        }
    }

    async function handleSubmitCustomPayment(e: FormEvent) {
        e.preventDefault()
        // validar data no front end tbm
        if (!customValue) {
            return toast.error('Digite um valor valido')
        }

        try {
            const { data } = await api.post('/pagamento/personalizado', {
                customValue: String(customValue).replace(',', '.'),
                dataLiquidacaoInicial,
                dataLiquidacaoFinal,
                cnpj_cpf,
            })

            if (data.error) {
                return toast.error(data.message)
            }

            // limpar o estado global
            if (data.unidadesRecebiveis.length > 0) {
                dispatch(actions.cercDeleteAllURs())
                data.unidadesRecebiveis.forEach((unidade: any) => {
                    dispatch(
                        actions.cercAddUR({
                            id: unidade.id,
                            agendaId: unidade.agendasId,
                            instituicaoCredenciadora:
                                unidade.instituicaoCredenciadora,
                            codigoArranjoPagamento:
                                unidade.codigoArranjoPagamento,
                            constituicao: unidade.constituicao,
                            dataLiquidacao: unidade.dataLiquidacao,
                            valorTotalUR: unidade.valorTotalUR,
                            valorConstituidoAntecipacaoPre:
                                unidade.valorConstituidoAntecipacaoPre,
                            valorConstituidoTotal:
                                unidade.valorConstituidoTotal,
                            valorBloqueado: unidade.valorBloqueado,
                            valorLivre: Number(unidade.valorLivre).toFixed(2),
                            valorLivreSelecionado: Number(
                                unidade.valorLivreSelecionado
                            ).toFixed(2),
                        })
                    )
                })
                navigate('/pagar')
                dispatch(
                    selectedMenu({
                        mainMenu: 'Pagar',
                        subMenu: '',
                        currentLink: '/pagar',
                    })
                )
                return
            }
            // alterar o estado global
            // redirecionar para o pagina de pagamento caso tenha dado tudo certo e exista unidades recebiveis

            return
        } catch (error) {
            const message = get(error, 'response.data.message', '')
            toast.error(message)
            return
        }
    }

    // function handleCheckBox(e: React.ChangeEvent<HTMLInputElement>, pagamento: any) {
    //     // verificar se o pagemento ja foi inserido no array
    //     if(pagamentos.some(pag => pag.id === pagamento.id)) {
    //         dispatch(actions.cercRemovePayment(pagamento.id))
    //     } else {
    //         dispatch(actions.cercAddPayment({
    //             id: pagamento.id,
    //             idUr: data?.id,
    //             agendaEntidadeRegistradora: data?.agendas?.entidadeRegistradora,
    //             AgendaInstituicaoCredenciadora: data?.agendas?.instituicaoCredenciadora,
    //             agendaCodigoArranjoPagemento: data?.agendas?.codigoArranjoPagamento,
    //             DPAgencia: pagamento.dp_agencia,
    //             DPNumeroConta: pagamento.dp_numeroConta,
    //             DPNumeroDocumentoTitular: pagamento.dp_numeroDocumentoTitular,
    //             DPTipoConta: pagamento.dp_tipoConta,
    //             pagBeneficiario: pagamento.beneficiario,
    //             pagValorOnerado: pagamento.valorOnerado,
    //             pagDataLiquidacaoEfetiva: pagamento.dataLiquidacaoEfetiva,
    //             uRDataLiquidacao: data?.dataLiquidacao,
    //             uRDocumentoTitular: data?.documentoTitular
    //         }))
    //     }
    // }

    function handleCheckBox(unidade: UnidadeRecebivelProtocol) {
        if (
            unidadesRecebiveisSelecionadas.some(
                (unidadeR) => unidadeR.id === unidade.id
            )
        ) {
            dispatch(actions.cercRemoveUR(unidade.id))
        } else {
            dispatch(
                actions.cercAddUR({
                    id: unidade.id,
                    agendaId: unidade.agendasId,
                    instituicaoCredenciadora:
                        unidade.agendas?.instituicaoCredenciadora,
                    codigoArranjoPagamento:
                        unidade.agendas?.codigoArranjoPagamento,
                    constituicao: unidade.constituicao,
                    dataLiquidacao: unidade.dataLiquidacao,
                    valorTotalUR: unidade.valorTotalUR,
                    valorConstituidoAntecipacaoPre:
                        unidade.valorConstituidoAntecipacaoPre,
                    valorConstituidoTotal: unidade.valorConstituidoTotal,
                    valorBloqueado: unidade.valorBloqueado,
                    valorLivre: Number(unidade.valorLivre).toFixed(2),
                    valorLivreSelecionado: Number(unidade.valorLivre).toFixed(
                        2
                    ),
                })
            )
        }
    }

    // function handleAllPayments(e: React.ChangeEvent<HTMLInputElement>) {
    //     if(e.currentTarget.checked) {
    //         dispatch(actions.cercDeleteAllPaymentsOfUr(data?.id))
    //         filtredPayments?.forEach((pagamento: any) => {
    //             dispatch(actions.cercAddPayment({
    //                 id: pagamento.id,
    //                 idUr: data?.id,
    //                 agendaEntidadeRegistradora: data?.agendas?.entidadeRegistradora,
    //                 AgendaInstituicaoCredenciadora: data?.agendas?.instituicaoCredenciadora,
    //                 agendaCodigoArranjoPagemento: data?.agendas?.codigoArranjoPagamento,
    //                 DPAgencia: pagamento.dp_agencia,
    //                 DPNumeroConta: pagamento.dp_numeroConta,
    //                 DPNumeroDocumentoTitular: pagamento.dp_numeroDocumentoTitular,
    //                 DPTipoConta: pagamento.dp_tipoConta,
    //                 pagBeneficiario: pagamento.beneficiario,
    //                 pagValorOnerado: pagamento.valorOnerado,
    //                 pagDataLiquidacaoEfetiva: pagamento.dataLiquidacaoEfetiva,
    //                 uRDataLiquidacao: data?.dataLiquidacao,
    //                 uRDocumentoTitular: data?.documentoTitular
    //             }))
    //         })
    //     } else {
    //         dispatch(actions.cercDeleteAllPaymentsOfUr(data?.id))
    //     }
    // }

    function handleSeeDetails(pagamento: PagamentoProtocol) {
        setSeeDetails(true)
        setSeeDetailsPayment(pagamento)
    }

    function handleOrderBy(order: string) {
        if (order === 'liquidacao') {
            const order = ordenarPorDataLiquidacao === 'asc' ? 'desc' : 'asc'
            setOrdenarPorDataLiquidacao(order)
            setOrdenarPorValor(null)
        } else if (order === 'valor') {
            const order = ordenarPorValor === 'asc' ? 'desc' : 'asc'
            setOrdenarPorValor(order)
            setOrdenarPorDataLiquidacao(null)
        }

        return
    }

    function formDialog(unidadesRecebiveis: UnidadeRecebivelProtocol) {
        setIsformDialogOpen(true)
        setFormDialogData(unidadesRecebiveis)
    }

    function renderTableRow() {
        return filtredPayments?.map((pagamento: PagamentoProtocol) => {
            // const isMarked = pagamentos.some((pag) => pag.id === pagamento.id)
            const codigoArranjoPagamento: any =
                data?.agendas?.codigoArranjoPagamento
            const codigo: keyof typeof arranjos = codigoArranjoPagamento
            const arranjo = arranjos[codigo]

            const dataLiquidacao: string =
                pagamento.dataLiquidacaoEfetiva || '2022-08-20'
            const dataLiquidacaoParsed = parseDate(dataLiquidacao)

            const diffDays = calcDiffDays(dataLiquidacaoParsed)
            return (
                <tr key={pagamento.id}>
                    <td>
                        <input className="checkbox" disabled type="checkbox" />
                    </td>
                    <td>{cnpjCpfMask(pagamento.beneficiario)}</td>
                    <td>
                        R${' '}
                        {Number(pagamento.valorOnerado).toLocaleString('pt-br')}
                    </td>
                    <td>
                        {parseDate(dataLiquidacao, true)} faltam {diffDays} dias
                    </td>
                    <td>{arranjo}</td>
                    <td
                        className="button"
                        onClick={() => handleSeeDetails(pagamento)}
                    >
                        <span>Ver detalhes</span>
                    </td>
                </tr>
            )
        })
    }

    async function handleChoiceUR(idUR: number) {
        const { data } = await api.get(`/pagamentos/${cnpj_cpf}/${idUR}`)
        setData(data)
    }

    function renderTableRowUR() {
        return unidadesRecebiveis?.map((unidade) => {
            const isMarked = unidadesRecebiveisSelecionadas.some(
                (unidadeR) => unidadeR.id === unidade.id
            )

            const codigoArranjoPagamento: any =
                unidade?.agendas?.codigoArranjoPagamento
            const codigo: keyof typeof arranjosPrincipais =
                codigoArranjoPagamento
            const arranjo = arranjos[codigo]

            const dataLiquidacaoParsed = parseDate(unidade.dataLiquidacao)
            const diffDays = calcDiffDays(dataLiquidacaoParsed)
            return (
                <tr key={unidade.id} className={isMarked ? 'marked' : ''}>
                    <td>
                        <input
                            className={
                                isMarked
                                    ? 'checkbox first selected'
                                    : 'checkbox first'
                            }
                            checked={isMarked}
                            onChange={(e) => handleCheckBox(unidade)}
                            type="checkbox"
                        />
                    </td>
                    <td onClick={(e) => handleChoiceUR(unidade.id)}>
                        {parseDate(unidade.dataLiquidacao, true)}
                    </td>
                    <td onClick={(e) => handleChoiceUR(unidade.id)}>
                        {diffDays} dias
                    </td>
                    <td
                        className=""
                        onClick={(e) => handleChoiceUR(unidade.id)}
                    >
                        <img
                            height={35}
                            width={70}
                            className="icon"
                            src={getIcon(codigo)}
                            alt="Icon bandeira cartão"
                        />
                        {/* {arranjo} */}
                    </td>
                    <td onClick={(e) => handleChoiceUR(unidade.id)}>
                        {Number(unidade.valorLivre).toLocaleString('pt-br', {
                            style: 'currency',
                            currency: 'BRL',
                        })}
                    </td>
                    <td className="edit">
                        <span onClick={(e) => formDialog(unidade)}>Editar</span>
                    </td>
                </tr>
            )
        })
    }

    function handleFlagChange(event: SelectChangeEvent<string[]>) {
        const value = event.target.value
        setBandeiras(typeof value === 'string' ? value.split(',') : value)
    }

    function changeDate(e: React.ChangeEvent<HTMLInputElement>) {
        setOrdenarPorPeriodo({
            ...ordenarPorPeriodo,
            [e.target.name]: e.target.value,
        })
    }
    return (
        <Container>
            <SearchAgenda>
                <div className="top-bar">
                    <h1>Consultar Agenda</h1>
                    <div className="right-side">
                        <div className="">
                            <label
                                htmlFor="credenciadora"
                                className="text-base text-gray-700 block sr-only"
                            >
                                Credenciadora:{' '}
                            </label>
                            <select
                                id="credenciadora"
                                value={credenciadora}
                                name="credenciadora"
                                onChange={(e) =>
                                    setCredenciadora(e.target.value)
                                }
                                className="cursor-pointer rounded-lg w-full flex-1 border border-gray-300 py-1 px-2 bg-white text-gray-700 placeholder-gray-400 shadow-sm text-base focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent"
                            >
                                {Object.entries(suasCredenciadoras).map(
                                    ([chave, valor]) => {
                                        // const exist = creds?.some((cred) => {
                                        //     return cred === chave
                                        // })

                                        return (
                                            <option key={chave} value={chave}>
                                                {valor}
                                            </option>
                                        )
                                    }
                                )}
                            </select>
                        </div>
                        <Link
                            to="/pagamento/criar"
                            className="payment-button"
                            onClick={() =>
                                dispatch(
                                    selectedMenu({
                                        mainMenu: 'Pagamento',
                                        subMenu: '',
                                        currentLink: '/pagamento',
                                    })
                                )
                            }
                        >
                            <button className="py-1 px-2 flex items-center gap-x-1 bg-green-600 hover:opacity-90 focus:ring-green-500 focus:ring-offset-green-200 text-white transition ease-in duration-100 text-center text-base font-normal shadow-md focus:outline-none focus:ring-2 focus:ring-offset-2 rounded-md">
                                {/* <BiLink size={22} /> */}
                                {/* <AiOutlinePlus size={20} /> */}
                                {/* <HiOutlinePlus size={22} /> */}
                                <BsPlus size={24} />
                                Criar pagamento
                            </button>
                        </Link>
                    </div>
                </div>
                <div className="bottom-bar">
                    <div>
                        <InputLabel
                            id="demo-multiple-chip-label"
                            className="sr-only"
                        >
                            Filtrar por:{' '}
                        </InputLabel>
                        <Select
                            labelId="demo-multiple-chip-label"
                            id="demo-multiple-chip"
                            sx={{
                                height: '34px',
                                minWidth: '200px',
                                borderRadius: '0.5rem',
                                borderColor: '#D1D5DB',
                            }}
                            className=" bg-white text-gray-700 placeholder-gray-400 shadow-sm text-base focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent mt-1"
                            multiple
                            value={bandeiras}
                            onChange={handleFlagChange}
                            renderValue={(selected) => {
                                return 'Bandeira'
                            }}
                        >
                            {Object.entries(arranjosPrincipais).map(
                                ([chave, valor]) => (
                                    <MenuItem key={chave} value={chave}>
                                        <Checkbox
                                            checked={
                                                bandeiras.indexOf(chave) > -1
                                            }
                                        />
                                        {/* <ListItemText primary={valor} /> */}
                                        <img
                                            height={35}
                                            width={40}
                                            src={getIcon(chave)}
                                            alt="Icon bandeira cartão"
                                        />
                                    </MenuItem>
                                )
                            )}
                        </Select>
                    </div>
                    {/* <form onSubmit={handleSubmit} id="ask-for-agenda">
                            <button
                                form="ask-for-agenda"
                                type="submit"
                                className="py-1 px-2 flex items-center gap-x-1 flex-shrink-0 bg-blue-600 hover:opacity-90 focus:ring-blue-500 focus:ring-offset-blue-200 text-white transition ease-in duration-100 text-center text-base font-normal shadow-md focus:outline-none focus:ring-2 focus:ring-offset-2 rounded-md "
                            >
                                Pedir nova agenda atualizada
                            </button>
                        </form> */}

                    <div className="right-side">
                        <DatePicker
                            selectsRange={true}
                            startDate={startDate}
                            endDate={endDate}
                            placeholderText="Selecione um período de data"
                            className=" flex-1 appearance-none border rounded-lg border-gray-300 bg-white py-1 px-4 text-gray-700 placeholder-gray-400 shadow-sm text-base focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent"
                            onChange={(update) => {
                                setDateRange(update)
                                // setFiltros({
                                //     ...filtros,
                                //     dataInicio:
                                //         dayjs(dataInicio).format('YYYY-MM-DD'),
                                //     dataFim: dataFim
                                //         ? dayjs(dataFim).format('YYYY-MM-DD')
                                //         : '',
                                // })
                            }}
                            dateFormat="dd/MM/yyyy"
                        />

                        <Popover className="popover">
                            <Popover.Button>
                                <button className=" appearance-none border rounded-lg border-gray-300 py-1 px-2 bg-white text-gray-700 placeholder-gray-400 shadow-sm text-base">
                                    <MdMoreVert size={24} />
                                </button>
                            </Popover.Button>
                            <Popover.Panel>
                                <div className="agenda">
                                    <form onSubmit={handleSubmit}>
                                        <ul>
                                            <li>
                                                <button
                                                    type="submit"
                                                    disabled={isLoading}
                                                >
                                                    Pedir nova agenda atualizada
                                                    {/* <MdLockOutline size={22} /> */}
                                                </button>
                                            </li>
                                            <li>
                                                <button
                                                    disabled={isLoading}
                                                    onClick={getAgenda}
                                                    type="button"
                                                >
                                                    Trazer agenda
                                                </button>
                                            </li>
                                        </ul>
                                        {/* <div className="actions">
                                            <Button
                                                disabled={isLoading}
                                                variant="contained"
                                                type="submit"
                                            >
                                                Pedir nova agenda atualizada
                                            </Button>
                                            <Button
                                                disabled={isLoading}
                                                onClick={getAgenda}
                                                variant="outlined"
                                            >
                                                Trazer agenda
                                            </Button>
                                        </div> */}
                                        {/* <span>* Pedir nova agenda gera um custo adicional</span> */}
                                    </form>
                                </div>
                            </Popover.Panel>
                        </Popover>
                    </div>
                </div>
            </SearchAgenda>

            {/* <Boleto /> */}

            {isLoading ? (
                <Loading />
            ) : (
                <Content>
                    <>
                        <ContainerUR>
                            <Header>
                                <div className="title">
                                    <h2>Unidades Recebiveis de {empresa}</h2>
                                    <span className="count">
                                        {unidadesRecebiveis?.length || 0}
                                    </span>
                                </div>
                            </Header>
                            <TableUR>
                                <thead>
                                    <tr>
                                        <th>
                                            <input
                                                disabled
                                                className="checkbox"
                                                type="checkbox"
                                            />
                                        </th>
                                        <th
                                            onClick={(e) =>
                                                handleOrderBy('liquidacao')
                                            }
                                            className={
                                                ordenarPorDataLiquidacao ===
                                                'asc'
                                                    ? 'order'
                                                    : 'order desc'
                                            }
                                        >
                                            Data de vencimento{' '}
                                            <MdKeyboardArrowUp size={18} />
                                        </th>
                                        <th>Prazo</th>
                                        <th>Bandeira</th>
                                        <th
                                            onClick={(e) =>
                                                handleOrderBy('valor')
                                            }
                                            className={
                                                ordenarPorValor === 'asc'
                                                    ? 'order'
                                                    : 'order desc'
                                            }
                                        >
                                            Valor disponível (UR){' '}
                                            <MdKeyboardArrowUp size={18} />
                                        </th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>{renderTableRowUR()}</tbody>
                            </TableUR>
                        </ContainerUR>
                        <div className="pagination">
                            <Pagination
                                onChange={(e, value) => setPagUR(value)}
                                page={pagUR}
                                count={count}
                                color="primary"
                                variant="outlined"
                                shape="rounded"
                            />
                        </div>
                    </>
                    {data.id && (
                        <>
                            <div className="cards">
                                <Schedule>
                                    <h2>Agenda</h2>
                                    <p>
                                        <span>Instituição credenciadora:</span>{' '}
                                        {
                                            data?.agendas
                                                ?.instituicaoCredenciadora
                                        }
                                    </p>
                                    <p>
                                        <span>Codigo arranjo pagamento:</span>{' '}
                                        {data?.agendas?.codigoArranjoPagamento}
                                    </p>
                                </Schedule>
                                <UnidadeRecebivel>
                                    <h2>Unidade recebivel</h2>
                                    <p>
                                        <span>Documento titular:</span>{' '}
                                        {cnpjCpfMask(cnpj_cpf)}
                                    </p>
                                    <p>
                                        <span>Data liquidação:</span>{' '}
                                        {parseDate(
                                            data?.dataLiquidacao || '',
                                            true
                                        )}
                                    </p>
                                    <p>
                                        <span>
                                            Valor total da unidade recebivel:
                                        </span>{' '}
                                        R$ {data?.valorTotalUR}
                                    </p>
                                    <p>
                                        <span>Valor livre:</span> R${' '}
                                        {data?.valorLivre}
                                    </p>
                                    <p>
                                        <span>Valor constituido total:</span> R${' '}
                                        {data?.valorConstituidoTotal}
                                    </p>
                                </UnidadeRecebivel>
                            </div>

                            {/* <Pagamentos>
                                    <Header>
                                        <div className="title">
                                            <h2>Pagamentos</h2>
                                            <span className='count'>{filtredPayments?.length || 0}</span>
                                        </div>
                                        <form>
                                            <div className="input-group">
                                                <InputLabel id="tipos-de-pagamentos-label">Tipos de pagamentos</InputLabel>
                                                <Select
                                                    sx={{ height: '30px' }}
                                                    labelId="tipos-de-pagamentos-label"
                                                    id="tipos-de-pagamentos-select"
                                                    value={paymentFilter}
                                                    label=""
                                                    onChange={(e) => setPaymentFilter(e.target.value)}
                                                >
                                                    <MenuItem value={0}>Disponíveis</MenuItem>
                                                    <MenuItem value={1}>Realizados</MenuItem>
                                                </Select>

                                            </div>
                                            <div className="input-group">
                                                <InputLabel id="data-range-label">Filtro de data</InputLabel>
                                                <Select
                                                    sx={{ height: '30px' }}
                                                    labelId="data-range-label"
                                                    id="data-range-select"
                                                    value={dateFilter}
                                                    label=""
                                                    onChange={(e) => setDateFilter(e.target.value)}
                                                >
                                                    <MenuItem value={0}>Sem limites</MenuItem>
                                                    <MenuItem value={15}>Até 15 dias</MenuItem>
                                                    <MenuItem value={30}>Até 30 dias</MenuItem>
                                                    <MenuItem value={45}>Até 45 dias</MenuItem>
                                                    <MenuItem value={60}>Até 60 dias</MenuItem>
                                                    <MenuItem value={90}>Até 90 dias</MenuItem>
                                                    <MenuItem value={120}>Até 120 dias</MenuItem>
                                                </Select>
                                            </div>

                                        </form>
                                    </Header>
                                    <Table>
                                        <thead>
                                            <tr>
                                                <th><input disabled className='checkbox' type="checkbox" /></th>
                                                <th>Beneficiário</th>
                                                <th>Valor onerado</th>
                                                <th>Data liquidação</th>
                                                <th>Arranjo de pagamento</th>
                                                <th></th>
                                            </tr>

                                        </thead>
                                        <tbody>
                                            {renderTableRow()}
                                        </tbody>
                                    </Table>
                                </Pagamentos> */}
                        </>
                    )}
                </Content>
            )}
            <Dialog
                isTermsOpen={seeDetails}
                setIsTermsOpen={setSeeDetails}
                title="Detalhes do pagamento"
            >
                <PaymentCard pagamento={seeDetailsPayment} />
            </Dialog>
            <FormDialog
                open={isformDialogOpen}
                setOpen={setIsformDialogOpen}
                unidadeRecebivel={formDialogData}
            />
        </Container>
    )
}

export default Pagamento
